<div #graph class="canvas">
  <div #tooltipSmallScreen class="tooltip"></div>
  <mat-progress-spinner color="primary" mode="indeterminate" class="loading" *ngIf="isLoading$ | async">
  </mat-progress-spinner>

  <div
    class="expand-all-nodes-button-small"
    (click)="expandAllNodes()"
    matTooltip="Expand all grouped nodes"
    matTooltipPosition="left"
  ></div>
  <div
    class="collapse-all-nodes-button-small"
    (click)="collapseAllNodes()"
    matTooltip="Collapse all eligible nodes"
    matTooltipPosition="left"
  ></div>
  <div
    class="fullscreen-enter-button"
    [hidden]="isFullScreen"
    (click)="setFullScreen(true)"
    matTooltip="Maximize view"
    matTooltipPosition="left"
  ></div>
</div>

<div #popup class="popup" [@fullscreen]="isFullScreen ? 'yes' : 'no'">
  <div #tooltipFullScreen class="tooltip"></div>

  <div
    class="expand-all-nodes-button-big"
    (click)="expandAllNodes()"
    matTooltip="Expand all grouped nodes"
    matTooltipPosition="left"
  ></div>
  <div
    class="collapse-all-nodes-button-big"
    (click)="collapseAllNodes()"
    matTooltip="Collapse all eligible nodes"
    matTooltipPosition="left"
  ></div>
  <div
    class="fullscreen-exit-button"
    [hidden]="!isFullScreen"
    (click)="setFullScreen(false)"
    matTooltip="Minimize view"
    matTooltipPosition="left"
  ></div>
</div>
